export default __webpack_public_path__ + "static/media/foto-exponente2.a5d744a1.png";